import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { Sidecar } from '@swf/poker';

import { usePokerMultiTableTournamentsWidget } from '../../model';

import styles from './SidecarContainer.scss';
import useDynamicHeightFromRows from './hooks/useDynamicHeightFromRows';

const CLASSES = {
  card: styles.sidecarCard,
  buttonsRoot: styles.sidecarButtonsRoot,
  buttonRegister: styles.sidecarButtonRegister,
  infoContainer: styles.sidecarInfoContainer
};

const SidecarContainer: React.FC = () => {
  const { widgetSelect } = usePokerMultiTableTournamentsWidget();
  const containerRef = useRef<HTMLDivElement>(null);
  const tournament = useSelector(widgetSelect.getSelectedTournament);
  useDynamicHeightFromRows(containerRef);

  return (
    <div className={styles.sidecar} ref={containerRef} data-testid="sidecar-container">
      <Sidecar
        classes={CLASSES}
        tournament={tournament}
        showRegisterButton
        showLobbyButton={false}
      />
    </div>
  );
};

export default SidecarContainer;
